import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { withStyles } from '@material-ui/core/styles';

import './styles.css';

class LogoHeader extends Component {
  render() {
    const { classes } = this.props;

    return (
      <AppBar position="sticky" className={classes.navigation}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.logoImage}>
            <img
              src={
                process.env.PUBLIC_URL + '/images/qwellLogo.png'
              }
              alt={'Qwell Logo'}
              className={classes.logoImage}
            />
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

const styles = () => ({
  logoImage: {
    width: '186px',
    height: '43px',
  },
  navigation: {
    width: '100%',
    height: '80px',
    backgroundColor: 'rgba(255,255,255,0.85)',
    boxShadow: 'rgba(0, 0, 0, 0.118) 0px 1px 3px 0px',
    color: '#000000',
    alignItems: 'left',
    borderRight: '1px solid #DCDCDC',
    paddingLeft: '1em',
    '@media only screen and (max-width: 1024px)': {
      height: '140px',
      paddingTop: '2em',
      padding: '1.5em',
    },
  },
});

export default withStyles(styles)(LogoHeader);
